import { ReferencedEntry } from 'contentful';
import { SomethingWentWrongPage } from 'src/components/ErrorPage/SomethingWentWrongPage';
import { FormWrapper } from 'src/components/Form/FormWrapper';
import { PartnerContactConfirmation } from 'src/components/IntegrationServices/PartnerContactConfirmation';
import { onRequestClose } from 'src/components/NestedRoute/NestedModals';
import { PartnerContactForm } from '../IntegrationServices/PartnerContactForm';

import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Subject } from 'src/api/contentful/contentTypes.cloverdotcom';
import { getField, isEntry } from 'src/utils/EntryUtil';

interface IPartnerContactWrapperState {
  isFormSubmitted?: boolean;
  errorSubmittingForm?: boolean;
}

interface IPartnerContactWrapperProps extends RouteComponentProps {
  entry?: ReferencedEntry<Subject>;
}

class PartnerContactWrapper extends React.Component<IPartnerContactWrapperProps, IPartnerContactWrapperState> {
  state: IPartnerContactWrapperState = {};

  render() {

    const { entry, history, match } = this.props;

    if (!isEntry(entry) || !history || !history.location) {
      return null;
    }

    const partner = getField(entry, 'title') || '';

    if (this.state.errorSubmittingForm) {
      return <SomethingWentWrongPage />;
    }
    if (this.state.isFormSubmitted) {
      return (
        <PartnerContactConfirmation
          partner={partner}
          onRequestClose={() => onRequestClose(history, match)}
        />
      );
    }
    return (
      <FormWrapper>
        <PartnerContactForm
          partner={partner}
          onSuccess={() => this.setState({ isFormSubmitted: true })}
          onError={() => this.setState({ errorSubmittingForm: true })}
          onRequestClose={() => onRequestClose(history, match)}
        />
      </FormWrapper>
    );
  }
}

const WithRouter = withRouter(PartnerContactWrapper);

export {
  WithRouter as PartnerContactWrapper
};
